import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientRegistrationNewEntity } from './client-registration-new.entity';
import { FileEntity } from './file.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk_client_registration_new__id', ['fkClientRegistrationNewId'], {})
@Entity('client_registration_new__file')
export class ClientRegistrationNewFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', nullable: true, unsigned: true })
	public fkFileId!: number | null;

	@Column('int', {
		name: '_fk_client_registration_new__id',
		nullable: true,
		unsigned: true,
	})
	public fkClientRegistrationNewId!: number | null;

	@ManyToOne(() => FileEntity, (file) => file.clientRegistrationNewFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(
		() => ClientRegistrationNewEntity,
		(clientRegistrationNew) => clientRegistrationNew.clientRegistrationNewFiles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_client_registration_new__id', referencedColumnName: 'id' },
	])
	public fkClientRegistrationNew!: ClientRegistrationNewEntity;
}
